import script from "./coupon.vue?vue&type=script&setup=true&lang=js"
export * from "./coupon.vue?vue&type=script&setup=true&lang=js"

import "./coupon.vue?vue&type=style&index=0&id=44442c7d&lang=scss"

const __exports__ = script;

export default __exports__